module.exports = __webpack_public_path__ + "static/media/YB5F16_3.c9ab8de2.jpg";